import { Welcome } from 'src/containers/Welcome';

export const WelcomePage = () => <Welcome />;
